module.exports = __webpack_public_path__ + "static/media/brazil.c77a6fec.svg";